import { useSelector } from "react-redux";
import AdminDocument from "./Admin-Document";
import AdminUsers from "./Admin-Users";
import { currentSelectedLanguage } from "../../../../../StateManagement/actions";


export default function AdminTabContainer() {
  const settings = useSelector((state) => state.settings);
  const selectedLanguage = useSelector(currentSelectedLanguage);


  const tabMap = {
    Personal: "personalTab",
    Company: "companyTab",
    Admin: "AdminTab",
  };
  const tabKey =
    tabMap[settings.settingFor === "User" ? "Personal" : settings.settingFor];


  return (
    <>
      {settings[tabKey]?.selectedTab === "Users" && <AdminUsers />}
      {settings[tabKey]?.selectedTab === "Document" && <AdminDocument />}
    </>
  );
}
